var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      staticClass: "detail-row text_small",
      class: { "detail-row--left": _vm.alignLeft }
    },
    [
      _c(
        "span",
        {
          staticClass: "detail-row__key",
          style: { width: _vm.colWidth[0] + "%", color: _vm.keyTextColor }
        },
        [_vm._v(_vm._s(_vm.prop))]
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      !_vm.$slots.default
        ? _c(
            "span",
            {
              staticClass: "detail-row__value",
              class: { capitalize: _vm.capitalize, bold: _vm.bold },
              style: { width: _vm.colWidth[1] + "%", color: _vm.valueTextColor }
            },
            [
              _c("span", {
                staticClass: "detail-row__value-text",
                attrs: { id: _vm.copiable ? "clipboard-target-" + _vm.id : "" },
                domProps: { innerHTML: _vm._s(_vm.value || "—") }
              }),
              _vm._v(" "),
              _vm.copiable
                ? _c(
                    "md-button",
                    {
                      staticClass: "detail-row__clipboard-btn md-icon-button",
                      attrs: {
                        id: "clipboard-btn",
                        "data-clipboard-target": "#clipboard-target-" + _vm.id
                      },
                      on: { click: _vm.showCopySuccess }
                    },
                    [
                      _c(
                        "md-icon",
                        {
                          staticClass:
                            "detail-row__clipboard-icon md-icon-size-065x"
                        },
                        [_vm._v("content_copy")]
                      ),
                      _vm._v(" "),
                      _c("md-tooltip", [_vm._v("Copy")])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-575d9abe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-575d9abe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/common/Detail.Row.vue
// module id = Run+
// module chunks = 1